import React, { Component } from "react";
import { connect } from "react-redux";

//Components
import ValueSlider from "./components/ValueSlider";

//MUI
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  List,
  Typography
} from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";

//Icons
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

function mapStateToProps(state) {
  return {
    data: state.data.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Styles
const styles = theme => ({
  root: {
    heading: "2em"
  }
});

class Air extends Component {
  state = {
    expanded: null,
    value: 0
  };

  handleExpandChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  generateSettings = (classes, expanded, data) => {
    const settings = Object.keys(data).map((a, i) => {
      return (
        <ExpansionPanel
          key={`${a}_${i}`}
          expanded={expanded === a}
          onChange={this.handleExpandChange(a)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>{a}</Typography>
          </ExpansionPanelSummary>

          {Object.keys(data[`${a}`]).map((s, i) => {
            return s === "Temp" ? (
              <ExpansionPanelDetails key={`${s}_${a}`}>
                {
                  <ValueSlider
                    data={data[a][s][i]}
                    label="Adjust Temperature"
                    dispatch={this.props.dispatch}
                  />
                }
              </ExpansionPanelDetails>
            ) : null;
          })}
        </ExpansionPanel>
      );
    });
    return <List component="nav">{settings}</List>;
  };

  render() {
    // eslint-disable-next-line
    const { classes, data } = this.props;
    const { expanded } = this.state;

    return (
      <div>
        <div>
          <Typography className={classes.heading}> Temperature </Typography>
          {this.generateSettings(classes, expanded, data)}
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Air));



// WEBPACK FOOTER //
// ./src/pages/user_dashboard/dashboard_tabs/Air.js